import { Params } from '@angular/router';
import { createAction, props } from '@ngrx/store';
import { IKycApplication } from '../../../core/models/onboarding.model';
import {
  IOnboardingSession,
  IOnboardingParams,
  IOnboardingKYC,
} from '../../../core/models/onboarding.model';
import { ICustomerValidate } from '@app/core/models/customer.model';

export const requestOnboardingSession = createAction(
  '[Auth] Request Onboarding Session',
  props<{ step: number }>()
);

export const successRequestOnboardingSession = createAction(
  '[Auth] Success Request Onboarding Session',
  props<{ information: IOnboardingSession }>()
);

export const failureRequestOnboardingSession = createAction(
  '[Auth] Failure Request Onboarding Session',
  props<{ message: string }>()
);

export const getPreCustomer = createAction('[Onboarding] Get PreCustomer');

export const validateBlockedByMultipleAttempts = createAction(
  '[Onboarding] Validate Blocked By Multiple Attempts',
  props<{ stepInfo: IOnboardingParams }>()
);

export const successGetPreCustomer = createAction(
  '[Onboarding] Success Get PreCustomer',
  props<{ stepInfo: IOnboardingParams }>()
);

export const failureGetPreCustomer = createAction(
  '[Onboarding] Failure Get PreCustomer',
  props<{ message: string }>()
);

export const saveOnboardingStep = createAction(
  '[Onboarding] Save Onboarding Step',
  props<{ stepInfo: IOnboardingParams }>()
);

export const successSaveOnboardingStep = createAction('[Onboarding] Success Save Onboarding Step');

export const failureSaveOnboardingStep = createAction(
  '[Onboarding] Failure Save Onboarding Step',
  props<{ message: string; formData: IOnboardingParams }>()
);

export const failureUpgradeCustomer = createAction(
  '[Onboarding] Failure Upgrade Customer',
  props<{ message: string }>()
);

export const successUpgradeCustomer = createAction('[Onboarding] Success Upgrade Customer');

export const saveAuth10tixStatus = createAction('[Onboarding] Save Auth10tix Status');

export const successSaveAuth10tixStatus = createAction(
  '[Onboarding] Success Save Auth10tix Status'
);

export const failureSaveAuth10tixStatus = createAction(
  '[Onboarding] Failure Save Auth10tix Status',
  props<{ message: string }>()
);

export const requestAuth10tixStatus = createAction('[Onboarding] Request Auth10tix Status');

export const successRequestAuth10tixStatus = createAction(
  '[Onboarding] Success Request Auth10tix Status',
  props<{ auth10tix: IOnboardingKYC }>()
);

export const failureRequestAuth10tixStatus = createAction(
  '[Onboarding] Failure Request Auth10tix Status',
  props<{ message: string }>()
);

export const setKYCApplication = createAction(
  '[Onboarding] Set KYC Application',
  props<{ application: IKycApplication | Params }>()
);

export const listentAuth10tixStatus = createAction('[Onboarding] Listen KYC Status');
// DEMO

export const setUnderReviewAuth10tixStatus = createAction(
  '[Onboarding] Set Under Review Auth10tix status',
  props<{ status: number }>()
);

export const setApprovedAuth10tixStatus = createAction(
  '[Onboarding] Set Approved Auth10tix Status',
  props<{ status: number }>()
);

export const setCustomerExists = createAction(
  '[Onboarding] Set Customer Exists',
  props<{ value: boolean }>()
);
export const setCustomerBlockedByMultipleAttempts = createAction(
  '[Onboarding] Set Customer Blocked By Multiple Attempts',
  props<{ value: boolean }>()
);

export const saveSecondOnboardingStep = createAction(
  '[Onboarding] Save Second Onboarding Step',
  props<{ stepTwoInfo: IOnboardingParams }>()
);

export const successSaveSecondOnboardingStep = createAction(
  '[Onboarding] Success Save Second Onboarding Step'
);

export const failureSaveSecondOnboardingStep = createAction(
  '[Onboarding] Failure Save Second Onboarding Step',
  props<{ message: string; secondFormData: IOnboardingParams }>()
);

export const setCaptchaDNIForm = createAction(
  '[Onboarding] Set Captcha DNI Form',
  props<{ token: string }>()
);

export const setNewOnboardingStep = createAction(
  '[Onboarding] Set New Onboarding Step',
  props<{ step: number }>()
);

export const nextOnboardingStep = createAction('[Onboarding] Go To Next Onboarding Step');

export const previousOnboardingStep = createAction('[Onboarding] Go To Previous Onboarding Step');

export const resetPrecustomerError = createAction('[Onboarding] Reset Precustomer Error Flags');

export const setIsLoadingOnboarding = createAction(
  '[Onboarding] Set Is Loading Onboarding',
  props<{ isLoading: boolean }>()
);

export const setIsPostLoading = createAction(
  '[Onboarding] Set Is Post Loading',
  props<{ isPostLoading: boolean }>()
);
